import { render, staticRenderFns } from "./SupportingInvestigation.vue?vue&type=template&id=54f008a6&scoped=true"
import script from "./SupportingInvestigation.vue?vue&type=script&lang=js"
export * from "./SupportingInvestigation.vue?vue&type=script&lang=js"
import style0 from "./SupportingInvestigation.vue?vue&type=style&index=0&id=54f008a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f008a6",
  null
  
)

export default component.exports